import { Injectable } from '@angular/core';
import { FormInfo } from '../from';

@Injectable({
  providedIn: 'root'
})
export class DatastoreService {
  //we maintain mapping & formedit state so we can only call formInfo for edited form only
  formInfoMapping:{[key:number]:FormInfo} = {}
  formEdited:number[] = []
  constructor() { }
}
